export const domainReformatter = text => {
    if (!text) return '';
    var fixedText = text.replace(/[^a-z0123456789\-.]/gi, '');
    fixedText = text.replace(/\.{2,}/gi, '.');
    return fixedText;
};